import { reducer } from 'ts-action';

import de from '../../locales/de.json';
import en from '../../locales/en.json';
import fr from '../../locales/fr.json';
import it from '../../locales/it.json';
import { flattenMessages } from '../../utils';

import { LocalesState } from './';

const initialState: LocalesState = {
    en: flattenMessages(en),
    it: flattenMessages(it),
    de: flattenMessages(de),
    fr: flattenMessages(fr),
};

export default reducer(initialState);
